<template>
  <el-container>
    <el-aside class="leftMenuContainer">
      <!--左侧工作区-->
      <el-col :span="24">
        <leftMenu activeIndex='3'></leftMenu>
      </el-col>
    </el-aside>
    <el-main class="work_container " style="overflow:auto">
      <el-row style="background-color: white;height: 100vh;">
        <el-row style="clear:both;height:40px"></el-row>
        <el-row>
          <el-col :span="5" :offset="1" class="t_l">
            <span class="pageTitle">我的素材库</span>

          </el-col>
          <el-col :span="11" class="t_r">
            <el-radio-group v-model="materType" size="large" @change="handlePageChange(1)">
              <el-radio-button label="全部">
                全部
              </el-radio-button>
              <el-radio-button label="图片">
                图片
              </el-radio-button>
              <el-radio-button label="图文">
                图文
              </el-radio-button>
              <el-radio-button label="文本">
                文本
              </el-radio-button>
              <el-radio-button label="表格">
                表格
              </el-radio-button>
            </el-radio-group>
          </el-col>
          <el-col :span="5" :offset="1" class="t_r">
            <el-input v-model="keyword" placeholder="请输入关键字" class="search-input" :clearable="true"
              suffix-icon="el-icon-search">
            </el-input>
          </el-col>
        </el-row>

        <el-col :span="22" :offset="1">
          <div class="upload_img_container">
            <el-button v-if="materType === '图片'" size="small" @click="uploadImgDialogVisible = true" class="addImgBtn">
              上传图片
            </el-button>
            <div style="clear:both"></div>
          </div>
          <div class=" infinite-list" v-infinite-scroll="getMateriaList" :infinite-scroll-delay=500
            :infinite-scroll-distance=100 :infinite-scroll-immediate=true :infinite-scroll-disabled='infiniteFinish'
            style="overflow:auto;height: calc(100vh - 180px);">
            <el-table :data="pageData" stripe style="width: 100%">
              <el-table-column prop="name" label="素材">
                <template #default="scope">

                  <span style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                    <span :class="'tag ' + scope.row.materType"> {{ scope.row.materType }}</span>

                    <a href="javascript:void(0)" @click="preview(scope.row)" style="text-decoration: none;color: #444;">
                      {{ scope.row.name }}
                    </a>
                  </span>
                  <!-- <el-link @click="preview(scope.row)" :underline="false"></el-link>
                    </el-link> -->

                </template>
              </el-table-column>
              <el-table-column prop="addTime" label="添加时间" width="180" />
              <!-- <el-table-column prop="materType" label="类型" width="100" /> -->
              <el-table-column prop="address" label="操作" width="160">
                <template #default="scope">
                  <el-link type="primary" @click="toWite(scope.row.id)">写作</el-link>
                  <el-link type="primary">|</el-link>
                  <el-popover placement="top-start" :width="60" trigger="click" :ref="'opt_popover' + scope.row.id">
                    <template #reference>
                      <el-link type="primary">更多</el-link>
                    </template>

                    <el-link @click="toRename(scope.row, scope.$index)">重命名</el-link><br>
                    <el-link type="danger" @click="toDelete(scope.row, scope.$index)">删除</el-link><br>

                  </el-popover>
                </template>
              </el-table-column>
              <template slot="empty">
                <div class="noFile"></div>
              </template>
            </el-table>
            <div style="clear:both"></div>
            <template v-if="infiniteFinish">
              <div class="noData" v-if="pageData.length > 0">
                <i class="iconfont">&#xe629;</i>
                数据加载完毕!
              </div>
            </template>
            <template v-else>
              <div class="noData">
                <span class="icon_run">
                  <i class="iconfont">&#xe67b;</i>
                </span>数据加载中...
              </div>
            </template>
          </div>
          <br>

        </el-col>
      </el-row>

    </el-main>

    <el-dialog :visible.sync="renameDialogVisible" title="重命名" custom-class="commonDialog" width="300px"
      :close-on-click-modal="false">
      <el-form>
        <el-form-item label="素材名称" label-width="100">
          <el-input v-model="curItem.name" autocomplete="off" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="renameDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="rename">
            确认
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog :visible.sync="deleteDialogVisible" custom-class="dangerDialog" title="删除" width="450px"
      :close-on-click-modal="false">
      确认删除文件？7天内可从回收站恢复已删除文件。
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="deleteDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="deleteMateria">
            确认
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!--上传图片对话框--->
    <el-dialog title="上传图片" :visible.sync="uploadImgDialogVisible" width="410px" :modal-append-to-body="true"
      :append-to-body="true">
      <el-upload class="upload-dialog" drag :on-success="imgUpSucc" :on-error="imgUpError" accept=".jpeg,.jpg,.png"
        :show-file-list=false action="/webApi/v3/material/uploadImg">
        <div class="upload_btn"></div>
        <div class="el-upload__text">将文件拖到此处，或<em>点击</em>上传</div>
        <div class="el-upload__tip" slot="tip" style="text-align: left;color:#909399">
          &nbsp;jpeg/jpg/png文件，且不超过500kb</div>
      </el-upload>
    </el-dialog>

    <el-dialog :append-to-body='true' :show-close=true width="800px" :visible.sync="previewDialogVisible"
      custom-class="previewDialog">
      <span slot="title">
        <h4>{{ curModel.name }}</h4>
        <!-- <div class="summary">{{ curModel.funSummary }}</div> -->

      </span>

      <div class="bgContainer">
        <div class="htmlContainer" v-html="curModel.context">
        </div>
      </div>
      <span slot="footer">
        <div class="previewFooter">
          <!-- <span>数据来源：<a href="http://www.csmar.com/">CSMAR</a></span> -->
          <span style="width: 500px;height: 10px;display: inline-block;">&nbsp;</span>
          <el-button size="mini" type="primary" style="margin-right: 0;" @click="toWite(curModel.id)">写作</el-button>
        </div>

      </span>
    </el-dialog>

  </el-container>
</template>

<script>

import leftMenu from '../components/left_menu'
import Loading from '../components/js/Loading.vue'
import * as appJs from '../assets/js/app'
export default {
  name: 'images',
  data: function () {
    return {
      keyword: '',
      curId: -1,
      loading: false,
      materType: '全部',
      infiniteFinish: false,
      pageData: [],
      renameDialogVisible: false,
      deleteDialogVisible: false,
      uploadImgDialogVisible: false,
      previewDialogVisible: false,
      curModel: {},
      curIndex: 0,
      curItem: {}
    }
  },
  watch: {

    keyword: function (val) {
      this.changeKeyword()
    }
  },
  methods: {
    changeKeyword () {
      this.curId = -1
      this.handlePageChange()
    },
    preview (val) {
      appJs.checkVip().then(() => {
        this.curModel = val
        this.previewDialogVisible = true
      })
    },
    toWite (materialId) { // 使用热点写作
      Loading.startLoading('弈写正在努力写作中，请稍等...')
      let _this = this

      this.axios.post('/webApi/v3/material/addWrite', { 'id': materialId }).then(resp => {
        if (!resp.data.autoNewsId) {
          this.$message('写作失败，请重试')
          return
        }
        _this.goDetail(resp.data.autoNewsId)
      })
    },
    // 跳转到详情页
    goDetail (articleId) {
      if (articleId) {
        this.$router.push({ path: '/newsEdit', query: { articleId: articleId } })
      } else {
        _this.$message.error('写作失败，请换个词试试');
      }
    },
    handlePageChange (page) {
      this.curId = -1
      this.pageData = []
      this.infiniteFinish = false
      this.getMateriaList()
    },
    rename (val) {
      let _this = this
      this.axios.post('/webApi/v3/material/rename', { 'name': this.curItem.name, 'id': this.curItem.id, '$noLoading': true }).then((response) => {
        _this.getMateriaList()
        _this.renameDialogVisible = false
        _this.pageData[this.curIndex].name = this.curItem.name
      })
    },
    toRename (val, curIndex) {
      this.curItem = JSON.parse(JSON.stringify(val))
      this.curIndex = curIndex
      this.renameDialogVisible = true
    },
    toDelete (val, index) {
      this.curIndex = index
      this.curItem = JSON.parse(JSON.stringify(val))
      this.deleteDialogVisible = true
    },

    deleteMateria () {
      let _this = this
      this.axios.get('/webApi/v3/material/delete?id=' + this.curItem.id).then((response) => {
        this.deleteDialogVisible = false
        _this.pageData.splice(_this.curIndex, 1)
      })
    },

    getMateriaList () {
      let _this = this
      let type = this.materType.replace('全部', '')

      this.axios.post('/webApi/v3/material/pageById', { 'articleId': _this.curId, 'keyword': this.keyword, 'materType': type, '$noLoading': true }).then((response) => {
        if (response.data === null || response.data.length < 10) {
          _this.infiniteFinish = true
        }
        _this.pageData = _this.pageData.concat(response.data)
        if (_this.pageData && _this.pageData.length > 0) {
          _this.curId = _this.pageData.slice(-1)[0].id
        }
      })
    },
    imgUpSucc (response, file, fileList) {
      let _this = this
      setTimeout(function () {
        if (response.code === 200) {
          _this.$notify({
            title: '成功',
            message: '文件上传成功',
            type: 'success'
          })
          _this.pageNo = 1

          _this.getMateriaList()
          _this.uploadImgDialogVisible = false
        } else {
          _this.$notify.error({
            title: '错误',
            message: response.msg
          })
        }
      }, 500)
    },
    imgUpError (errorInfo, file, fileList) {
      this.$notify.error({
        title: '错误',
        message: '文件【' + file.name + '】上传失败'
      })
    }

  },
  components: {

    leftMenu
  },
  mounted () {

  }
}
</script>
<style lang="less"  scoped>
.work_container {
  padding: 0px;
  padding-left: 20px;
  overflow-y: auto;
}

.upload-dialog {
  margin: auto;
  text-align: center;

  .upload_btn {
    background-image: url("../assets/imgs/add_img_icon.png");
    width: 40px;
    height: 50px;
    margin: auto;
    background-size: 100% 100%;
    margin-top: 40px;
    margin-bottom: 20px;
  }
}

.imgOpreateContainer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-image: linear-gradient(to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.6));
  color: white !important;
  height: 00px;
  overflow: hidden;

  .imgName {
    width: calc(100% - 40px);
    text-align: left;
    padding: 10px 0px;
    display: inline-block;
    font-size: 0.9em;
  }

  .deleteBtn {
    display: inline;
    color: white !important;
    font-size: 1.1em;
  }
}

.xy_container {
  margin-top: 10px;
}

.xy_card {
  margin-top: 10px;
}

.second_article_desc {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 0.8em;
  color: #ccc;
  text-align: left;
}

.second_article_title {
  text-align: left;
  margin-top: 5px;
}
</style>
<style lang="less" scoped>
.upload_img_container {
  margin: 10px 0px;
  height: 30px;
  text-align: right;

  .addImgBtn {
    background-color: #A8D1FF;
    color: white;
  }
}

.t_r {
  text-align: right;
}

.t_l {
  text-align: left;
}
</style>
<style lang="less">
.search-input {
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #DCDFE6;
  width: 225px;

  .el-input__inner {
    border-top: 0px;
    border-left: 0px;
    border-bottom: 0px;
    border-right: 0px solid #DCDFE6;
    ;
  }

  .el-input-group__append {
    border: 0px;
    background-color: #0000;
    width: 0px;
    border: 0px;
    padding: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/app/material.vue